/**
 * Central export file for all context providers and hooks
 */

// Export all providers
export { UserProvider, useUser } from './UserProvider';
export { ThemeProvider, useTheme } from './ThemeProvider';
export { NotificationProvider, useNotifications } from './NotificationProvider';
export { UIProvider, useUI } from './UIProvider';
export { ProductProvider, useProduct, useProductOptional } from './ProductProvider';
export { ChatMessageProvider, useChat } from './ChatMessageProvider';
export { ListingProvider, useListing } from './ListingProvider';
// SellProvider and EditListingProvider are page-scoped — import directly from their files
export { SearchProvider, useSearch } from './SearchProvider';
export { AppSessionProvider, useAppSession } from './AppSessionProvider';
export { UnifiedAuthProvider, useUnifiedAuth } from './UnifiedAuthProvider';
export { CategoryProvider, useCategory } from './CategoryProvider';
export { CheckoutProvider, useCheckout } from './CheckoutProvider';
export { RouterProvider, useRouterContext } from './RouterProvider';
export { CompositeAppProvider } from './CompositeAppProvider';

// Export types
export type { UserProfile, UserContextType } from './UserProvider';
export type { Theme, ThemeContextType } from './ThemeProvider';
export type { 
  Notification, 
  NotificationType, 
  NotificationContextType 
} from './NotificationProvider';
export type { 
  LoginView, 
  PostViewState, 
  MobileTopNav, 
  UIContextType 
} from './UIProvider';
export type { 
  Product, 
  ProductContextType 
} from './ProductProvider';
export type { 
  ChatMessage, 
  ChatCompanion, 
  ChatProduct, 
  Chat, 
  ChatContextType 
} from './ChatMessageProvider';
export type {
  ListingFields,
  ListingContextType
} from './ListingProvider';
export type {
  SearchFilters,
  SearchParams,
  SearchResult,
  SearchContextType,
  RecentCategory
} from './SearchProvider';
export type {
  Transaction,
  Address,
  SessionContextType
} from './AppSessionProvider';